import React from "react";
import Bundles from "../Components/Bundle";

const MainBundle = () => {
	return <Bundles />;
};

export default MainBundle;
